import { render, staticRenderFns } from "./IconProfileDetails.vue?vue&type=template&id=81fe5ec2&"
import script from "./IconProfileDetails.vue?vue&type=script&lang=js&"
export * from "./IconProfileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81fe5ec2')) {
      api.createRecord('81fe5ec2', component.options)
    } else {
      api.reload('81fe5ec2', component.options)
    }
    module.hot.accept("./IconProfileDetails.vue?vue&type=template&id=81fe5ec2&", function () {
      api.rerender('81fe5ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProfileDetails.vue"
export default component.exports